import styled from '@emotion/styled'

import theme from 'styles/theme'

export const StyledPagination = styled.div`
  display: flex;
  justify-content: center;

  .pagination_container {
    display: flex;
    justify-content: center;
    min-width: 300px;
  }

  .pagination_page {
    width: 36px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: black;
    background: transparent;
    transition: background 0.3s ease;
    border-radius: 100%;
    font-size: ${theme.token.var('fontSizes.sm')};
    line-height: ${theme.token.var('fontSizes.sm')};
    margin: 0 2px;
  }

  .pagination_page a {
    cursor: pointer;
  }

  .pagination_active {
    color: ${theme.token.var('colors.white')};
    background: ${theme.token.var('colors.green.a200')};
  }

  .break {
    list-style-type: none;
  }

  .previous,
  .next {
    display: none;
  }
`

export const PageButton = styled.button<{ isActive: boolean }>`
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ isActive }) => (isActive ? theme.token.var('colors.white') : theme.token.var('colors.black'))};
  background: ${({ isActive }) => (isActive ? theme.token.var('colors.green.a200') : 'transparent')};
  transition: background 0.3s ease;
  border-radius: 100%;
  font-size: ${theme.token.var('fontSizes.sm')};
  line-height: ${theme.token.var('fontSizes.sm')};
  margin: 0 2px;
  cursor: pointer;

  &:hover {
    background: ${theme.token.var('colors.green.a125')};
  }
`
